import { useEffect, useState } from 'react';

function useFilter<T extends { [key in string]: any }>(items: T[], query: string) {
  const [filteredItems, setFilteredItems] = useState<T[]>([]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFilteredItems(filterData(items, query));
    }, 300);
    return () => clearTimeout(timeout);
  }, [items, query]);

  return filteredItems;
}

// TODO: better filtering e.g. nested attributes, array values
function filterData<T extends Record<string, any>>(data: T[], query: string) {
  return data.filter((it) =>
    Object.values(it).some((value) =>
      query
        .split(' ')
        .every((queryTerm) => String(value).toLowerCase().includes(queryTerm.toLowerCase()))
    )
  );
}

export default useFilter;
